import React from 'react';

import { defineMessages } from 'react-intl';

import AccountPageTemplate from '~/account/components/AccountPageTemplate';
import ReviewsLayout from '~/account/components/ReviewsLayout';
import {
  allComponents,
  registerBuilderComponents,
  registerBuilderMenu,
} from '~/builder/utils/registerBuilderComponents';
import { isFullyAuthenticated } from '~/shared/utils/isFullyAuthenticated';
import { loadReviewableProducts } from '~/techstyle-shared/react-accounts';

import createPage from '../../registry';

const messages = defineMessages({
  title: {
    id: 'site_account_reviews.reviews_header',
    defaultMessage: 'Reviews',
  },
});

function ReviewsPage() {
  return (
    <AccountPageTemplate title={messages.title}>
      <ReviewsLayout />
    </AccountPageTemplate>
  );
}

ReviewsPage.propTypes = {};

ReviewsPage.getInitialProps = async (ctx) => {
  if (await isFullyAuthenticated(ctx)) {
    await ctx.store.dispatch(loadReviewableProducts());
  }
};

registerBuilderComponents(allComponents);
registerBuilderMenu();

export default createPage(ReviewsPage, {
  resourceBundles: [
    'site_navigation',
    'site_account_billship',
    'site_account_rewards',
    'site_account_reviews',
    'site_contact_us',
  ],
  prefetchAssets: [
    'membership_html_freetrialbenefits',
    'membership_html_downgraded_member_benefits',
    'membership_html_upsellmodal',
  ],
});
